import React, { useEffect, useMemo, useState } from 'react';
import ReportGijgoGrid from '../../internal/ReportsScreens/GijgoForReportsScreen';
import formatters from '../../../Core/Grid/inputFormatter';
import { SquareButton } from '../../../Core/FormInput/AppButton';
import { Grid } from '@material-ui/core';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb';
import ReactDOM from 'react-dom';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import DialogComp from '../../../Core/Modal/dialogModal';
import VmrsCategoryModal from './vmrsCategoryModal';

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'VMRS Categories', active: true }
];

const base_columns = [
    { field: 'action', title: 'Action', width: '5%' },
    { field: 'vmrsDescription', title: 'Description' },
    { field: 'nominalCode', title: 'Nominal Code', width: '14%' },
    { field: 'customerName', title: 'Customer Code', width: '14%' },
    { field: 'vehicleTypeDescription', title: 'Vehicle Type', width: '14%' },
    { field: 'vmrsType', title: 'VMRS Type', width: '14%' }
];

const VmrsCategory = (props) => {
    const [state, setState] = useState({
        vmrsCategoryList: [],
        loader: true,
        modalToggle: false
    });

    const pullMakeData = async () => {
        setState((st) => ({
            ...st,
            isReload: new Date()
        }));
    };

    const handleMakeUpdate = (params) => {
        setState((state) => ({ ...state, modalToggle: true, userID: params?.vmrsCategoryID }));
    };

    const editButton = (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container alignItems="center" justifyContent="center">
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px 0px 0px 0px'
                    }}
                    onClick={() => handleMakeUpdate(record)}
                >
                    <EditIcon fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const addButton = (gridRef, valueList) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="center" style={{ paddingRight: '7px' }}>
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px 0px 0px 0px',
                        marginLeft: '20px'
                    }}
                    onClick={() => handleMakeUpdate()}
                >
                    <AddIcon fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        let newColumn = [...base_columns];
        let actionCol = newColumn.find((item) => item.field === 'action');
        if (actionCol) {
            actionCol.renderer = editButton;
        }
        return newColumn;
    }, []);

    const title = state.userID ? 'Update VMRS Category' : 'Add VMRS Category';

    const closeMakeDialog = (res) => {
        setState((state) => ({ ...state, modalToggle: false }));
        res && pullMakeData();
    };

    return (
        <div className="report-screen-container">
            <BreadCrumbs crumbs={crumbs} />
            <ReportGijgoGrid
                dataConverter={(res) => ({
                    records: res.data.list,
                    total: res.data.total
                })}
                columns={columns}
                getUrl={'VMRSCategory'}
                AddBtn={addButton}
                isReload={state.isReload}
            />
            {state.modalToggle ? (
                <DialogComp title={title} onClose={() => closeMakeDialog(false)} maxWidth="md">
                    <VmrsCategoryModal vmrsCategoryID={state.userID} onClose={() => closeMakeDialog(true)} />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default VmrsCategory;
